export const exportToCSV = (filename: string, data: any[], headerList: string[]) => {

  let csvData = convertToCSV(data, headerList);

  let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
  downloadFile(blob, filename + ".csv");

}

const convertToCSV = (objArray: any[], headerList: string[]) => {
  let csvStr = '';
  let row = '';
  for (let index in headerList) {
    row += `"${headerList[index]}",`;
  }
  row = row.slice(0, -1);
  csvStr += row + '\r\n';
  for (let rowObj of objArray) {
    row = '';
    for (let index in rowObj) {
      row += `"${(rowObj[index]) ?? ''}",`;
    }
    row = row.slice(0, -1);
    csvStr += row + '\r\n';
  }
  return csvStr;
}

const downloadFile = (blob: Blob, filename: string) => {
  let dwldLink = document.createElement("a");
  let url = URL.createObjectURL(blob);
  let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
  if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
    dwldLink.setAttribute("target", "_blank");
  }
  dwldLink.setAttribute("href", url);
  dwldLink.setAttribute("download", filename);
  dwldLink.style.visibility = "hidden";
  document.body.appendChild(dwldLink);
  dwldLink.click();
  document.body.removeChild(dwldLink);
}